import { getSelectorRoot } from 'utils/selectors';

const getEventsSelector = getSelectorRoot('events');

export const getEvents = getEventsSelector('events');
export const getSports = getEventsSelector('sports');
export const getSelectedSport = getEventsSelector('selectedSport');
export const getSelectedEventsType = getEventsSelector('selectedEventsType');
export const getTimeFilter = getEventsSelector('timeFilter');
